import moment from "moment";
import ReactDatePicker from "react-datepicker"

interface IMonthCalendarProps {
  startDate: Date | null | undefined;
  endDate: Date | null | undefined;
  onChange: (date: [Date | null, Date | null]) => void;
}

const MonthContent = (month: number, shortMonth: string, longMonth: string) => {
  return <div className="px-2 py-2">{shortMonth}</div>;
};

export const MonthCalendar = ({ startDate, endDate, onChange}: IMonthCalendarProps) => {
  return (
    <ReactDatePicker
      selected={startDate}
      onChange={(date) => {
        const start = moment(date).toDate();
        const end = moment(date).endOf('month').toDate();
        onChange([start, end])
      }}
      calendarStartDay={1}
      startDate={startDate}
      endDate={endDate}
      calendarClassName="!border-0"
      inline
      disabledKeyboardNavigation
      showMonthYearPicker={true}
      renderMonthContent={MonthContent}
    />
  )
}